<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    Choose Columns
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <mat-selection-list [(ngModel)]="selectedColumns">
    <mat-list-option *ngFor="let col of data.allColumns"
                     [value]="col.key"
                     [disabled]="col.fixed">

      {{ col.label }}

    </mat-list-option>
  </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onClose()">Close</button>
  <button mat-raised-button color="primary"
          (click)="saveColumns()">
    Apply
  </button>
</mat-dialog-actions>
